"use strict";
// packages/contracts/src/estorno.ts — Fase 10, Plano 09 (REM-08, D-30..D-33).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=estorno.js.map